import * as React from "react";
const SvgLessThanEqual = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 15.5 9.25 10l8.25-5.5-1-1.5L6 10l10.5 7z",
  fillRule: "evenodd",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 20.998H6v-2h12z",
  fill: "currentColor"
}));
export default SvgLessThanEqual;